// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__aU6VJ","title":"Contact_title__1En-b","subtitle":"Contact_subtitle__qHnk1","links":"Contact_links__mODcI","card":"Contact_card__XTjaQ"};